import { getPerformance } from '@paperstac/firebase/lib/performance';
import useFirestoreSubscribe from '@paperstac/hooks/lib/useFirestoreSubscribe';
import React from 'react';
var useCurriedFirestoreSubscribe = function useCurriedFirestoreSubscribe(reference) {
  var inputs = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  return useFirestoreSubscribe(reference, inputs, getPerformance());
};
export default useCurriedFirestoreSubscribe;